import { render, staticRenderFns } from "./CartaoInformacoesLeitos.vue?vue&type=template&id=a77227d0&scoped=true"
import script from "./CartaoInformacoesLeitos.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesLeitos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77227d0",
  null
  
)

export default component.exports